import axios from "axios";

export const apiRequest = async ({
  url,
  method,
  payload,
  headers,
  withCredentials = false,
}: {
  url: string;
  method: "POST" | "GET";
  payload: object;
  headers?: object;
  withCredentials?: boolean;
}) => {
  const { data } = await axios({
    url,
    method,
    data: payload,
    headers,
    withCredentials,
  });

  return data;
};

export const path = window.__ENV__?.REACT_APP_API_URL ?? process.env.REACT_APP_API_URL;

export const apiKeys = {
  "connection.definition": `${path}/v1/connection-definitions`,
  "connection.create": `${path}/v1/connections`,
  "connections.oauth": `${path}/v1/connections/oauth/authorize`,
  "track": `${path}/v1/public/mark`,
  "check.connection.state": `${path}/v1/connections/oauth/check`,
  'connection.oauth.definition': `${path}/v1/connection-oauth-definitions`,

};

export const remoteKeys = {
  getIntegrationDefinitions: "integration.definitions.get",
  listIntegrationDefinitions: "integration.definitions.list",
  getConnectionDefinition: "connection.definition.get",
  listConnectionDefinitions: "connection.definitions.list",
  getEmbedToken: "embed.token.get",
  updateEmbedToken: "embed.token.update",
  getConnectionOauthDefinition: "connection.oauth.definition.get",
  getConnectedPlatforms: "connected.platforms.get",
};
